export const isOpen = state => state.getIn(['stopDescription', 'isOpen'])
export const mediaType = state => state.getIn(['stopDescription', 'mediaType'])
